import React, { useState } from "react"
import { createReview } from "../store"
import { useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import Rating from "./ui/Rating"
import "./styles/ReviewForm.css"

const ReviewForm = () => {
  const [description, setDescription] = useState("")
  const [rating, setRating] = useState(1)
  const dispatch = useDispatch()
  const { id } = useParams()

  const handleSubmit = (event) => {
    event.preventDefault()

    const newReview = {
      productId: id,
      description,
      rating,
    }

    dispatch(createReview(newReview))

    setDescription("")
    setRating("")
  }

  return (
    <div className="review-form">
      <div className="review-form-title">Leave a Review</div>
      <form onSubmit={handleSubmit}>
        <textarea
          className="review-form-textarea"
          value={description}
          onChange={(event) => setDescription(event.target.value)}
        />
        <div className="review-form-rating">
          <Rating rating={rating} onSelect={setRating} />
        </div>
        <div className="review-form-actions">
          <button
            disabled={description === "" || rating === ""}
            type="submit"
            className="review-form-button"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  )
}

export default ReviewForm
